import React from 'react';
import withIcon from '../utilities/withIcon';

const IconJumpToQuestion = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm4.286 7.465c.26.261.283.67.07.957l-.07.083-2.519 2.53-.082.07a.73.73 0 0 1-.86.008l-.092-.078-2.519-2.53-.07-.083a.738.738 0 0 1-.008-.865l.078-.092.082-.07a.73.73 0 0 1 .861-.008l.092.078 2 2.011 2.002-2.01.082-.072a.73.73 0 0 1 .953.071zm-5.1-5.57.081.07 2.519 2.53a.737.737 0 0 1 0 1.04.73.73 0 0 1-.953.07l-.082-.07L6.75 5.024l-2.001 2.01a.73.73 0 0 1-.953.072l-.082-.071a.738.738 0 0 1-.07-.957l.07-.083 2.519-2.53a.73.73 0 0 1 .952-.07z" />
    </g>
  );
};

export default withIcon(IconJumpToQuestion);
